import { post, get } from "../util/crmAxios";

//账号管理---
//修改用户信息
export const updateUserById = (params) => post('/crm/account/updateUserById', params);
//分页查询账号信息
export const queryAccountListByPage = (params) => post('/crm/account/queryAccountListByPage', params);
//删除用户
export const deleteUserById = (params) => get('/crm/account/deleteUserById', params);
//启用账号
export const enableUser = (params) => get('/crm/account/enableUser', params);
//新增用户
export const addUser = (params) => post('/crm/account/addUser', params);
//查询权限配置
export const queryConfigNav = (params) => get('/crm/account/queryConfigNav', params);
//查询权限列表（功能集合）
export const queryConfigFunctions = (params) => get('/crm/account/queryConfigFunctions', params);
//查询角色配置
export const queryConfigRoles = (params) => get('/crm/account/queryConfigRoles', params);
//查询账户下跟进学员人数
export const queryCustomNum = (params) => get('/crm/account/queryCustomNum', params);
//根据用户id修改密码
export const updateUserPwdById = (params) => get('/crm/account/updateUserPwdById', params);
//根据用户id查询用户信息
export const queryUserInfoById = (params) => get('/crm/account/queryUserInfoById', params);
//校区角色移除-new
export const removeCampusRole = (params) => post('/crm/account/removeCampusRole', params);
//禁用账号
export const disableUser = (params) => get('/crm/account/disableUser', params);
//查询学员 师生关系
export const getRelations = (params) => get('/erp/relation/getRelations', params);
//查询学员 师生关系 New
export const getRelationsV2 = (params) => get('/erp/relation/getRelationsV2', params);

//查询学员 师生关系
export const opSingleRelation = (params) => post('/erp/relation/opSingleRelation', params);
//查询学员 师生关系 New
export const opBatchRelationV2 = (params) => post('/erp/relation/opBatchRelationV2', params);

//新查询权限配置
export const queryDepNav = (params) => get('/crm/account/queryDepNav', params);
//新查询权限配置
export const queryDepNavFunctions = (params) => get('/crm/account/queryDepNavFunctions', params);
//查询校区角色-new
export const queryCampusRoles = (params) => get('/crm/account/queryCampusRoles', params);
//查询校区系统角色-new
export const queryCampusSysRoles = (params) => get('/crm/account/queryCampusSysRoles', params);
//查询校区角色详情-new
export const queryCampusRoleInfo = (params) => post('/crm/account/queryCampusRoleInfo', params);
//查询校区角色详情-new
export const addModifyUserNavFun = (params) => post('/crm/account/addModifyUserNavFun', params);
//新增校区角色-new
export const addCampusRole = (params) => post('/crm/account/addCampusRole', params);
//校区角色修改-new
export const modifyCampusRole = (params) => post('/crm/account/modifyCampusRole', params);
//新增用户-new
export const addUserInfo = (params) => post('/crm/account/addUserInfo', params);
//修改用户-new
export const updateUserInfo = (params) => post('/crm/account/updateUserInfo', params);
//批量分配-人员列表（学员跟进）
// export const getSubUsers = (params) => post('/crm/user/getSubUsers', params);
export const getSubUsers = (params) => {
    return new Promise(async (resolve, reject) => {
        const keyName = `CRM_SUBUSERS`
        let DictionarysList = JSON.parse(sessionStorage.getItem(keyName) || '[]');
        // if ( DictionarysList.length <= 0 ) {
        if (true) {
            DictionarysList = await post('/crm/user/getSubUsers', params)
            DictionarysList = DictionarysList.code === 0 ? DictionarysList.data : []
            sessionStorage.setItem(keyName, JSON.stringify(DictionarysList))
            resolve({
                code: 0,
                data: DictionarysList
            })
        } else {
            resolve({
                code: 0,
                data: DictionarysList
            })
        }
    })
};
// 删除账号数据迁移（学员跟进）
export const migrateCustom = (params) => post('/crm/customerfollow/migrateCustom', params);

//校验用户密码
export const checkCurrentUserPassword = (params) => get('/crm/account/checkCurrentUserPassword', params);
//获取短信验证码
export const getCode = (params) => get('/crm/user/getCode', params);
//绑定手机号
export const bindUserMobile = (params) => get('/crm/account/bindUserMobile', params);
//根据用户id获取手机号
export const getUserMobileById = (params) => get('/crm/account/getUserMobileById', params);


/**
 * 新增
 */
// 校验手机号验证码
export const checkValidCode = (params) => post('/crm/user/checkValidCode', params);
// 更换登录手机号
export const changeLoginPhoneBySelf = (params) => post('/crm/user/changeLoginPhoneBySelf', params);

//获取部门菜单和功能列表左侧的数据
export const getCurrentDepNavAndFun = (params) => get('/crm/account/getCurrentDepNavAndFun', params);
//获取菜单功能权限和数据权限
export const getCurrentDataFun = (params) => get('/crm/account/getCurrentDataFun', params);
// 保存自定角色权限
export const addModifyCampusRole = (params) => post('/crm/account/addModifyCampusRole', params);
// 编辑校区自定义角色
export const queryRoleAuthInfo = (params) => post('/crm/account/queryRoleAuthInfo', params);
// 账户新增角色 保存权限接口
export const modifyUserNavFun = (params) => post('/crm/account/modifyUserNavFun ', params);
// 根据ID查询已经保存的用户的权限
export const getUserAuthById = (params) => get('/crm/account/getUserAuthById', params);
// 登录后手机验证码验证
export const checkPhoneCode = (params) => post('/crm/user/checkPhoneCode', params);

// 获取短信验证码
export const getPhoneCode = (params) => get('/crm/user/getPhoneCode', params);
// 验证验证码
export const checkPhoneCodeFree = (params) => post('/crm/user/checkPhoneCodeFree', params);



